<template>
  <IdeaActivityUpdateNotification
    :notification="notification"
    changedLabel="Description"
  >
    <BaseSubHeading
      size="medium"
      color="monochrome-06"
      darkColor="monochrome-03"
      weight="400"
      className="
        notification__update-item__content
        notification__update-item__description
        idea-activity-update__description
      "
    >
      <ReferencedText
        :resetStyle="true"
        :html="notification.descriptionHtml"
      />
    </BaseSubHeading>

    <NotificationAttachmentFiles
      v-if="notification.attachments.length"
      :attachments="notification.attachments"
      :url="notification.ideaUrl"
      :attachmentsCount="notification.attachmentsCount"
    />
  </IdeaActivityUpdateNotification>
</template>

<script setup lang="ts">
import IdeaActivityUpdateNotification from "@/components/Notification/components/IdeaActivityUpdateNotification.vue"
import NotificationAttachmentFiles from "@/components/Notification/components/NottificationAttacmentFiles.vue"
import { ReferencedText } from "@/components/Reference"

import { NotificationIdeaActivity } from "@/models/Notification"

/** Renders the Idea description change with the new description underneath. */
defineProps<{
  notification: NotificationIdeaActivity
}>()
</script>
